import React from "react";

import { Container, Title } from './styles/ParagraphContainer';

export default function GuideParagraph({ title, children }) {
  return (
    <Container>
      {title && <Title>{title}</Title>}
      {children}
    </Container>
  );
}
